(function($) {

    // Get Window Width and Height
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();
  
    /* Document ready functions */
    jQuery(document).ready(function ($){
  
      if ('.fullscreen'){
        $('.hero-images.fullscreen').css({"height":windowHeight -40});
        if (windowWidth < 768) {
            $('.hero-images.fullscreen').css({"height":windowHeight});
        }
      }
      
      // Hero images
      var swiper = new Swiper('.hero-images.swiper-container', {
        autoplay: {
          delay: 7000,
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 1500,
        allowTouchMove: false,
      });
  
      var swiper2 = new Swiper('.grid-item .swiper-container', {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 100,
        allowTouchMove: false,
      });

      // Image gallery
      var swiper3 = new Swiper('.image-gallery .swiper-container', {
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })

      // Large imahge gallery (full width)
      var swiper3 = new Swiper('.large-image-gallery .swiper-container', {
        loop: true,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })


      // Start living swiper function on mobile
      windowWidth = $(window).outerWidth();
      if (windowWidth < 767) {
        var swiper4 = new Swiper('.living .swiper-container', {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
          },
        });
      }


  
    });
  
    jQuery(window).resize(function ($) {
  
      // Get Window Width and Height on resize
      windowWidth = $(window).outerWidth();
      windowHeight = $(window).height();
  
      $('.hero-images.fullscreen').css({"height":windowHeight -40});
      if (windowWidth < 768) {
          $('.hero-images.fullscreen').css({"height":windowHeight});
      }
  
    });
  
  })(jQuery);
  